export class LinkInfoDto {
    constructor(
        public isNewTab: boolean,
        public url?: string, 
        public queryParams?: {[key: string]: any}
    ){}
}